export default __webpack_public_path__ + "static/media/52_1_1.eeabf5de.png";